var SideSearch = new Class({
	Implements: [Options, Events],

	options: {
		cls:'w_side_search'
	},

	initialize: function(_element, options){
		this.setOptions(options);
		this._element = _element || document.getElement('.' + this.options.cls);

		if(!this._element) return;

		this.build();
	},

	build: function(){
		var opts	= this.options,
				fcls	= '.' + opts.cls,
				self = this;

		var _form_boxes = this._element.getElements('.form_box');

		_form_boxes.each(function(_el){
			_el.addEvent('click', function(e){
				e.stopPropagation();
			});
		});

		if(_form_boxes.length == 0){
			this._element.addEvent('click:relay(' + fcls + '_item)', function(e, _el){
				var url = _el.getAttribute('data-page-url');

				if(url){
					window.location = url;
				}
			});
		}else if(_form_boxes.length == 1){
			var _item = this._element.getElement('.form_box').getParent(fcls + '_item');

			_item.addClass('_forcibly_opened');

			this.open(_item);

			this._element.addEvent('click:relay(' + fcls + '_item)', function(e, _el){
				if(_el === self._opened) return;

				if(e && e.stop) e.stop();

				if(!_el.getElement('.form_box')){
					var url = _el.getAttribute('data-page-url');

					if(url){
						window.location = url;
					}
				}
			});
		}else{
			this._element.addEvent('click:relay(' + fcls + '_item)', function(e, _el){
				if(e && e.stop) e.stop();

				if(self._opened && self._opened === _el){
					if(!self.is_search_form(e.target)){
						self.close();
						self.hide_veil();
					}
				}else{
					self.open(_el);
					self.show_veil();
				}
			});

			$(document.body).addEvents({
				'click': function(e){
					if(self._opened && e.target != self._opened && !e.target.getParent('.w_side_search_item')){
						self.close();
						self.hide_veil();
					}
				}
			});
		}
	},

	add_quest: function(_el){
		if(_el.quest) return;

		var _miniquest = _el.getElement('.w_miniquest');

		if(!_miniquest) return;

		if(Browser.platform == 'ios' || Browser.platform == 'webos' || Browser.platform == 'android'){
			_miniquest.addClass('_mobile');
		}

		_el.quest = new QuestExt(_miniquest, {
			type: _el.get('data-type'),

			onRegionsListOpen: function(){
				_el.addClass('_regions_opened');
			},
			onRegionsListClose: function(){
				_el.removeClass('_regions_opened');
			},
			onHasResults: function(){
				_miniquest.getElement('.submitter').removeClass('_no_results');
			},
			onNoResults: function(){
				_miniquest.getElement('.submitter').addClass('_no_results');
			}
		});

		var _checkboxes = _miniquest.getElements('.w_styled_checkbox');

		if(_checkboxes && _checkboxes.length > 0){
			_checkboxes.each(function(_el){
				new StyledCheckbox(_el);
			});
		}

		if(_el.quest._reset){
			var reset_wrapper = this._element.getElement('.reset_li') || _el.quest._submitter;
			_el.quest._reset.inject(reset_wrapper);
		}
		if(_el.quest._save){
			_el.quest._save.inject(_miniquest);
		}
	},

	open: function(_el){
		this.close();

		_el.addClass('_opened');
		this._element.addClass('_open');

		this.add_quest(_el);
		this.move_quest_results(_el);
		this.update_content(_el);

		this._opened = _el;
	},

	close: function(){
		if(!this._opened) return;

		this._opened.removeClass('_opened');
		this._element.removeClass('_open');

		this._opened = null;
	},

	move_quest_results: function(_el){
		var _results_matches = _el.getElement('.w_miniquest_results_matches');
		var _monitor = _el.getElement('.results_monitor');

		if(_results_matches && _monitor){
			_results_matches.inject(_monitor, 'top');
		}
	},

	update_content: function(_el){
		var type = _el.hasClass('transactions')? 'Closed Sales' : _el.hasClass('sale')? 'Sale' : 'Rent';
		var text = _el.hasClass('transactions')? ' Total ' :' Total Apts for ';
		var _monitor = _el.getElement('.results_monitor');

		text = _monitor.getElement('span.text').get('data-total') + text + type;
		_monitor.getElement('span.text').set('text', text);
	},

	show_veil: function(){
		if(!this._veil){
			this._veil = new Element('.w_side_search_veil');

			this._veil.inject($(document.body));

			this._veil.addEvent('click', function(){
				this.close();
				this.hide_veil();
			}.bind(this));
		}

		this._veil.show();
		this._element.addClass('_on_top');
	},

	hide_veil: function(){
		this._veil.hide();
		this._element.removeClass('_on_top');
	},

	is_search_form: function(_el){
		return _el.hasClass('.form_box') || _el.getParent('.form_box')
	}
});
